import { mapGetters } from 'vuex'

export default {
    computed: {
        ...mapGetters('user', ['isDemoUser'])
    },
    methods: {
        isDemoUserMode() {
            if (this.isDemoUser) {
                this.$notify({
                    title: 'Не поддерживается в демо-версии',
                    type: 'error'
                })
                return true
            }

            return false
        }
    }
}
